var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMagnifyingGlass(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0,0,255.98959,255.98959",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.1082,-0.03551) scale(0.5,0.5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,512) scale(0.1,-0.1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1865,5114c-207,-20 -364,-52 -522,-108c-712,-248 -1212,-860 -1324,-1621c-19,-126 -16,-433 5,-564c69,-437 262,-820 564,-1118c386,-383 873,-583 1417,-583c377,0 764,111 1065,306c39,25 73,44 74,42c1,-1 11,-25 21,-53c10,-27 31,-68 46,-90c15,-22 301,-313 636,-647c662,-661 643,-644 783,-670c124,-23 269,24 363,119c95,94 142,239 119,363c-26,140 -9,121 -670,783c-334,335 -625,621 -647,636c-22,15 -62,36 -90,46c-27,10 -51,20 -53,21c-2,1 19,38 47,82c198,316 301,678 301,1057c0,541 -198,1025 -576,1411c-297,302 -681,498 -1114,569c-94,15 -367,27 -445,19zM2218,4595c236,-35 478,-133 662,-268c523,-384 739,-1049 543,-1672c-110,-349 -378,-671 -710,-852c-354,-193 -805,-231 -1188,-101c-970,331 -1329,1515 -706,2327c281,365 707,576 1174,580c70,0 171,-6 225,-14z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnifyingGlass);
export default __webpack_public_path__ + "static/media/magnifying-glass.651852dda86279e8d4bc826863845474.svg";
export { ForwardRef as ReactComponent };